import { memo, useContext, useEffect, useState } from 'react';
import {
  BefPageContainerServiceProvider,
  BefPageControllerService,
  BefPageControllerContext,
  BefPageContainer,
  BefGlobalContext,
  BefMenuServiceContext,
  IBefMenuElement,
  BefPage,
  BefRpcContext,
} from '@beflam/bef-core';
import { PageContainer } from './PageContainer';
import { getUrlQueryParams } from '../renderer/utils';
import { BefPluginProxyDataService } from '../service/bef-plugin-proxy-data-service';
import BeflamChat from '../renderer/components/BeflamChat';
import { Agent } from './Agent/Agent';
import './Content.css';
declare var $: any;

function ContainerInner(props: { container: any }) {
  const container = props.container;
  return (
    <BefPageContainerServiceProvider key={container.id}>
      <PageContainer key={container.id} container={container} />
    </BefPageContainerServiceProvider>
  );
}

const MemoContainer = memo(
  ContainerInner,
  (prevProps, nextProps) => prevProps.container.id === nextProps.container.id
);

export function Content(prop: any) {
  const { isSinglePage, initEvent, pluginPageInitEvent } = prop;
  const menu = useContext(BefMenuServiceContext);
  const sGlobal = useContext(BefGlobalContext);
  const sRpc = useContext(BefRpcContext);

  const pageController: BefPageControllerService = useContext(
    BefPageControllerContext
  );
  const [pageContainer, pageContainerSet] = useState<BefPageContainer[]>([]);
  const [isChatVisible, setIsChatVisible] = useState({
    visible: false,
    type: '',
    params: {} as any,
  });
  const [isReduceChat, setIsReduceChat] = useState(true);
  useEffect(() => {
    const pageContainersChangedSub =
      pageController.pageContainersChanged.subscribe((result) => {
        pageContainerSet(result);
      });
    const initEventSub = initEvent.subscribe(async (result: any) => {
      let commandUrlQuery = getUrlQueryParams(window.location.search);
      // if (commandUrlQuery?.commandid) {
      //   result.INITCOMMANDID = commandUrlQuery.commandid;
      // }
      // if (commandUrlQuery?.moduleid) {
      //   result.INITAPPID = commandUrlQuery.moduleid;
      // }
      // if (result.INITCOMMANDID && result.INITAPPID) {
      //   sGlobal.currentModuleId = result.INITAPPID;
      //   let _menu: IBefMenuElement = {
      //     ID: '',
      //     Text: '',
      //     Icon: '',
      //     HoverIcon: '',
      //     Command: result.INITCOMMANDID,
      //     HasIcon: false,
      //     IsImage: false
      //   };
      //   menu.openMenu(_menu, result.INITAPPID);
      // }
      if (commandUrlQuery?.menuid) {
        result.INITCOMMANDID = commandUrlQuery.menuid;
      }
      if (commandUrlQuery?.moduleid) {
        sGlobal.currentModuleId = commandUrlQuery.moduleid;
      }
      //这里 rpcProxyId 是从Designer来的，rpcDirect是从iframe来的，都不要触发页面打开逻辑，所以加上这个判断
      if (!sRpc.rpcProxyId && !sGlobal.rpcDirect) {
        if (
          commandUrlQuery &&
          commandUrlQuery.moduleid &&
          commandUrlQuery.page
        ) {
          const pagedataStr = commandUrlQuery?.pagedata;
          let pagedata = null;
          if (
            pagedataStr &&
            typeof pagedataStr === 'string'
          ) {
            //如果pagedataStr没有以{开头和}结尾，那么就添加上
            let correctedStr = pagedataStr;
            if (!pagedataStr.trim().startsWith('{')) {
              correctedStr = '{' + correctedStr;
            }
            if (!pagedataStr.trim().endsWith('}')) {
              correctedStr = correctedStr + '}';
            }
            pagedata = JSON.parse(correctedStr);
          }
          menu.openPage(
            commandUrlQuery.moduleid,
            'Page',
            `${commandUrlQuery.pagegroup || ''}${commandUrlQuery.page}`,
            undefined,
            pagedata,
          );
        } else if (
          commandUrlQuery &&
          commandUrlQuery.moduleid &&
          commandUrlQuery.anaid
        ) {
          let _menu: IBefMenuElement = {
            ID: '',
            Text: '',
            Icon: '',
            HoverIcon: '',
            ModuleId: commandUrlQuery.moduleid,
            CommandType: 'Query',
            Command: commandUrlQuery.anaid,
            HasIcon: false,
            IsImage: false,
          };
          menu.openMenu(_menu);
        } else if (result.INITCOMMANDID) {
          menu.openPageByMenuID(result.INITCOMMANDID, 'Web');
        } else if (
          result.HomePage &&
          result.HomePage.ModuleId &&
          result.HomePage.PageId
        ) {
          sGlobal.currentModuleId = result.HomePage.ModuleId;
          menu.openPage(
            result.HomePage.ModuleId,
            'Page',
            result.HomePage.PageId,
            result.HomePage.Title
          );
        }
      }

      if (sRpc.rpcProxyId && BefPluginProxyDataService.isProxy())
        BefPluginProxyDataService.notifyOnLoad();
    });

    const pluginPageInitEventSub = pluginPageInitEvent.subscribe(
      (result: BefPage) => {
        pageController.show(result);
      }
    );

    let chatVisibleType = '';
    let chatParams = {};
    const aiVisibleEventSub = sGlobal.aiVisibleEvent.subscribe(
      (params: any) => {
        if (params.visible) {
          chatVisibleType = params.type;
          chatParams = params.params;
          setIsChatVisible(params);
        } else {
          //关闭的参数需要跟开启的最后一个chat参数完全一致
          setIsChatVisible({
            ...params,
            type: chatVisibleType,
            params: chatParams,
          });
        }
      }
    );
    return () => {
      pageContainersChangedSub.unsubscribe();
      initEventSub.unsubscribe();
      pluginPageInitEventSub.unsubscribe();
      aiVisibleEventSub.unsubscribe();
    };
  }, []);

  //chat在时触发关闭侧边page事件
  const _closeAllTabs = () => {
    var len = pageController.pageContainers.length;
    for (let i = len - 1; i > -1; i--) {
      pageController.close(pageController.pageContainers[i]);
    }
  };

  return (
    <div
      className="no-content-chat"
      style={{
        display: 'flex',
        flexDirection: 'row',
        height: isSinglePage ? '100%' : '',
      }}
    >
      {!sRpc.rpcProxyId && (
        <div
          style={{
            flex: isReduceChat ? 1 : 3,
            height: '100%',
            minWidth: 381,
            display: isChatVisible.visible ? 'block' : 'none',
          }}
        >
          <div style={{ position: 'relative', height: '100%', width: '100%' }}>
            <div className="App-chat-menu">
              <svg
                viewBox="0 0 1024 1024"
                width="26px"
                height="26px"
                fill="currentColor"
                className="App-chat-navbar-minimalize"
                onClick={() => {
                  $('body').toggleClass('App-chat-mini-navbar');
                  setIsReduceChat(!isReduceChat);
                }}
              >
                <path d="M426.666667 469.333333a42.666667 42.666667 0 1 0 0 85.333334v-85.333334z m426.666666 85.333334a42.666667 42.666667 0 1 0 0-85.333334v85.333334z m-426.666666 0h426.666666v-85.333334H426.666667v85.333334z"></path>
                <path d="M456.832 481.834667a42.666667 42.666667 0 0 0-60.330667 60.330666l60.330667-60.330666z m110.336 230.997333a42.666667 42.666667 0 0 0 60.330667-60.330667l-60.330667 60.330667z m-170.666667-170.666667l170.666667 170.666667 60.330667-60.330667-170.666667-170.666666-60.330667 60.330666z"></path>
                <path d="M396.501333 481.834667a42.666667 42.666667 0 0 0 60.330667 60.330666l-60.330667-60.330666z m230.997334-110.336a42.666667 42.666667 0 0 0-60.330667-60.330667l60.330667 60.330667z m-170.666667 170.666666l170.666667-170.666666-60.330667-60.330667-170.666667 170.666667 60.330667 60.330666zM213.333333 170.666667a42.666667 42.666667 0 0 0-85.333333 0h85.333333zM128 853.333333a42.666667 42.666667 0 1 0 85.333333 0H128zM128 170.666667v682.666666h85.333333V170.666667H128z"></path>
              </svg>
            </div>
            {isChatVisible.type === 'agent' ? (
              <Agent
                onOK={undefined}
                onDialogChanged={undefined}
                onClose={undefined}
              />
            ) : (
              <BeflamChat
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                }}
                viewType={isChatVisible.type}
                aiUser={isChatVisible.params?.colleague}
                initConversation={isChatVisible.params?.initConversation}
                isReduceChat={isReduceChat}
                backHandler={isChatVisible.params?.backHandler}
                clickChatList={() => {
                  if (pageContainer.length > 0 && isReduceChat) {
                    setIsReduceChat(false);
                    $('body').toggleClass('App-chat-mini-navbar');
                  }
                }}
              />
            )}
          </div>
        </div>
      )}
      <div
        style={{
          flex: 3,
          height: '100%',
          display: pageContainer.length > 0 ? 'block' : 'none',
        }}
      >
        {!isSinglePage && !sGlobal.isSpa && (
          <div className="content-tabs">
            <button className="roll-nav roll-left J_tabLeft">
              <i className="fa fa-backward"></i>
            </button>
            <nav className="page-tabs J_menuTabs">
              <div className="page-tabs-content"></div>
            </nav>
            <button
              className="roll-nav roll-right J_tabRight"
              style={{ right: '100px' }}
            >
              <i className="fa fa-forward"></i>
            </button>
            <div
              className="btn-group roll-nav roll-right J_tabExit"
              style={{ right: '10px', zIndex: 999 }}
            >
              <button className="dropdown J_tabClose" data-toggle="dropdown">
                CloseActions<span className="caret"></span>
              </button>
              <ul role="menu" className="dropdown-menu dropdown-menu-right">
                <li className="J_tabShowActive">
                  <a>CurrentTab</a>
                </li>
                <li className="divider"></li>
                <li className="J_tabCloseAll">
                  <a>CloseAllTabs</a>
                </li>
                <li className="J_tabCloseOther">
                  <a>CloseOtherTabs</a>
                </li>
              </ul>
            </div>
          </div>
        )}

        <div
          className={
            sGlobal.isSpa ? 'J_mainContent no-content-tabs' : 'J_mainContent'
          }
          style={{ position: 'relative', height: isSinglePage ? '100%' : '' }}
          id="content-main"
        >
          {pageContainer.map((container) => {
            return (
              <div
                key={container.id}
                style={{
                  display: container.isActive ? undefined : 'none',
                  position: 'absolute',
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  overflow: 'auto',
                  zIndex: 998,
                }}
              >
                <MemoContainer container={container} />
              </div>
            );
          })}
          <div
            className="App-chat-close-btn"
            onClick={() => {
              _closeAllTabs();
            }}
            style={{
              display: isChatVisible.visible ? undefined : 'none',
              position: 'absolute',
              top: 5,
              right: 3,
              zIndex: 998,
            }}
            aria-label="关闭"
          >
            <svg viewBox="0 0 24 24" width="20" height="20">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}
